import React, { useState, useEffect } from 'react';
import './GameModal.css';
import PortfolioGame from './PortfolioGame';

const GameModal = () => {
    const [showModal, setShowModal] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [hasPlayed, setHasPlayed] = useState(false); // Used in handlers
    
    // Note: Game autoplay removed - game only launches from About page button
    // The hasPlayed state is kept for potential future use
    useEffect(() => {
        const gameCompleted = localStorage.getItem('portfolioGameCompleted');
        if (gameCompleted) {
            setHasPlayed(true);
        }
    }, []);
    
    useEffect(() => {
        // Prevent scrolling when modal is shown
        if (showModal) {
            document.body.classList.add('game-modal-active');
        } else {
            document.body.classList.remove('game-modal-active');
        }
        
        return () => {
            document.body.classList.remove('game-modal-active');
        };
    }, [showModal]);
    
    const handleGameComplete = () => {
        localStorage.setItem('portfolioGameCompleted', 'true');
        setHasPlayed(true);
        setShowModal(false);
        
        // Add a nice success message that fades in
        const successMessage = document.createElement('div');
        successMessage.className = 'game-success-message';
        successMessage.innerHTML = '<p>🎉 Adventure complete! Welcome to my portfolio.</p>';
        document.body.appendChild(successMessage);
        
        // Remove the message after a few seconds
        setTimeout(() => {
            successMessage.style.opacity = '0';
            setTimeout(() => {
                document.body.removeChild(successMessage);
            }, 500);
        }, 3000);
    };
    
    const handleSkip = () => {
        localStorage.setItem('portfolioGameCompleted', 'true');
        setHasPlayed(true);
        setShowModal(false);
    };
    
    const handleSectionUnlock = (section) => {
        console.log(`Section unlocked: ${section}`);
    };
    
    // Allow launching the game from elsewhere in the site
    window.launchPortfolioGame = () => {
        setShowModal(true);
    };
    
    if (!showModal) return null;
    
    return (
        <div className="game-modal-overlay" onClick={handleSkip}>
            <div className="game-modal-content game-is-active" onClick={e => e.stopPropagation()}>
                <div className="game-modal-close" onClick={handleSkip}>×</div>
                <PortfolioGame 
                    onComplete={handleGameComplete} 
                    onSkip={handleSkip}
                    onSectionUnlock={handleSectionUnlock}
                />
            </div>
        </div>
    );
};

export default GameModal;